var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4684 8V6C14.4684 3.23858 12.1895 1 9.37827 1C6.5671 1 4.28818 3.23858 4.28818 6V8M9.37827 12.5V14.5M6.12062 19H12.6359C14.3464 19 15.2016 19 15.8549 18.673C16.4295 18.3854 16.8967 17.9265 17.1895 17.362C17.5224 16.7202 17.5224 15.8802 17.5224 14.2V12.8C17.5224 11.1198 17.5224 10.2798 17.1895 9.63803C16.8967 9.07354 16.4295 8.6146 15.8549 8.32698C15.2016 8 14.3464 8 12.6359 8H6.12062C4.41019 8 3.55497 8 2.90167 8.32698C2.32702 8.6146 1.85981 9.07354 1.567 9.63803C1.23413 10.2798 1.23413 11.1198 1.23413 12.8V14.2C1.23413 15.8802 1.23413 16.7202 1.567 17.362C1.85981 17.9265 2.32702 18.3854 2.90167 18.673C3.55497 19 4.41019 19 6.12062 19Z",
    stroke: "#636874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGrey);
export default __webpack_public_path__ + "static/media/lock-grey.ec2fc8e672055437a167db7587dc3ff9.svg";
export { ForwardRef as ReactComponent };